import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
    },
    mutations: {
        // 设置用户信息
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        // 退出登录（清空用户信息）
        CLEAR_USER_INFO(state) {
            state.userInfo = {}
            localStorage.removeItem('userInfo')
        }
    },
    actions: {
        // 退出 action
        logout({commit}) {
            commit('CLEAR_USER_INFO')
        }
    },
    getters: {
        isLogin: state => !!state.userInfo.token,
        userName: state => state.userInfo.username || state.userInfo.phone
    }
})
